module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-router-page-transition-290.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-router-page-transition.md
// module id = 734
// module chunks = 210